export const TOKEN_GET_PARAM_NAME = 'token';
